/** @format */
import Cookies from "js-cookie";
export async function getModel(token) {
  const api_url = Cookies.get("ApiUrl");
  const apiUrl = `${api_url}/model/list`;

  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        Authorization: token,
      },
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data.message.list;
  } catch (error) {
    throw new Error(error);
  }
}
